import script from "./UserCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCard.vue?vue&type=script&setup=true&lang=js"

import "./UserCard.vue?vue&type=style&index=0&id=142b4bcc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-142b4bcc"]])

export default __exports__